import { defineStore } from 'pinia'
import SensorGroupSensorState, { SensorGroupSensorStateType } from './state'
import { SensorGroupSensorActions, SensorGroupSensorActionsType } from './actions'
import { SensorGroupSensorGetters } from './getters'

export const useSensorGroupSensorStore = defineStore<
  'sensorGroupSensor',
  SensorGroupSensorStateType,
  typeof SensorGroupSensorGetters,
  SensorGroupSensorActionsType
>('sensorGroupSensor', {
  state: SensorGroupSensorState,
  actions: SensorGroupSensorActions,
  getters: SensorGroupSensorGetters,
})
